const selectLoader = (state) => state.partner.self.loader
const selectError = (state) => state.partner.self.error
const selectData = (state) => state.partner.self.data
const selectTimeFilter = (state) => state.partner.self.timeFilter
const selectCompaniesFilter = (state) => state.partner.self.companiesFilter
const selectSearch = (state) => state.partner.self.search
const selectPage = (state) => state.partner.self.page
const selectSortProperty = (state) => state.partner.self.sortProperty
const selectIncidentsLoader = (state) => state.partner.self.incidentsLoader
const selectStatisticsLoader = (state) => state.partner.self.statisticsLoader
const selectAddCompanyLoader = (state) => state.partner.self.addCompanyLoader
const selectAddCompanyMessage = (state) => state.partner.self.addCompanyMessage
const selectPossibleAcquiringPartners = (state) => state.partner.self.possibleAcquiringPartners
const selectMigrateCompanyLoader = (state) => state.partner.self.fetching

export {
  selectLoader,
  selectError,
  selectData,
  selectSearch,
  selectPage,
  selectSortProperty,
  selectTimeFilter,
  selectCompaniesFilter,
  selectIncidentsLoader,
  selectStatisticsLoader,
  selectAddCompanyLoader,
  selectAddCompanyMessage,
  selectPossibleAcquiringPartners,
  selectMigrateCompanyLoader,
}
